import { mapState } from "vuex";
import AppPopover from "@/components/AppPopover";
import CurrencyValue from "@/components/tableElements/CurrencyValue.vue";
export default {
  name: "SpendEvolutionCandle",
  components: {
    AppPopover,
    CurrencyValue
  },
  props: {
    data: {
      type: Object,
      required: true
    },
    maxValue: {
      type: Number,
      default: 0
    },
    selected_period: {
      type: String,
      default: "14 days"
    },
    index: {
      type: Number,
      required: true
    },
    workspace_id: {
      type: String,
      default: ""
    },
    seller_id: {
      type: String,
      default: ""
    },
    hovering_workspace_id: {
      type: String,
      default: ""
    },
    hovering_seller_id: {
      type: String,
      default: ""
    },
    hovering_index: {
      type: Number,
      default: -1
    }
  },
  data() {
    return {
      uid: "",
      periodRange: {
        "14 days": 1,
        "12 weeks": 7,
        "12 months": 30,
        "12 quarters": 90
      }
    };
  },
  computed: {
    ...mapState({}),
    height() {
      return this.maxValue <= 0 ? 0 : (Math.abs(this.data.evol_value) / this.maxValue * 26.5).toFixed(1) + "px";
    },
    calculateDateString() {
      if (!this.data.label) {
        return "-";
      }
      const date1 = new Date(this.data.label);
      const date2 = new Date(date1);
      date2.setDate(date2.getDate() + this.periodRange[this.selected_period]);
      const date1_str = `${date1.getDate()} ${date1.toLocaleDateString(navigator.language, {
        month: "short"
      })}`;
      const date2_str = `${date2.getDate()} ${date2.toLocaleDateString(navigator.language, {
        month: "short"
      })} ${date2.getFullYear()}`;
      return `${date1_str} - ${date2_str}`;
    },
    isHovering() {
      return this.hovering_index === this.index && this.hovering_workspace_id === this.workspace_id && this.hovering_seller_id === this.seller_id;
    }
  },
  methods: {
    onHovering() {
      this.$emit("displayPopover", this.index, this.workspace_id, this.seller_id);
    },
    onLeaving() {
      this.$emit("displayPopover", -1, "", "");
    }
  }
};